import { SiteWiseAssetCache } from './cache';
import { RequestProcessor } from './requestProcessor';
export class SiteWiseAssetModule {
    constructor(api) {
        this.api = api;
        this.assetCache = new SiteWiseAssetCache();
        this.requestProcessor = new RequestProcessor(this.api, this.assetCache);
    }
    startSession() {
        return this.requestProcessor.startSession();
    }
}
